import LabServiceModel from "@/models/LabServiceModel";
import StaffCollection from "@/collections/lab/StaffCollection"

export default class WorkGroupModel extends LabServiceModel {
  modelName() {
    return "work-group";
  }
  icon() {
    return "user-tag";
  }
  defaults() {
    return {
      id: null,
      name: null,
      description: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      role_id: null,
      role: null,
      staffs: [],
    };
  }
  mutations() {
    return {
      id: (val) => this.nullStringMutator(val),
      name: (val) => this.nullStringMutator(val),
      description: (val) => this.nullStringMutator(val),
      role_id: (val) => this.nullStringMutator(val),
      created_at: String,
      updated_at: String,
      deleted_at: String,
    };
  }
  getTestTasks() {
    return this.getRelatedCollection(new StaffCollection(), "staffs");
  }
  validation() {
    return {};
  }
}
